/**
 * How the polygons are filled.
 *
 * Both levels are at 0.65 today. The two constants are kept apart on purpose: they have already
 * been tuned separately (the sections went 0.85 -> 0.5 -> 0.65 on their own) and will be again.
 */

export const PROVINCE_FILL_OPACITY = 0.65
export const SECTION_FILL_OPACITY = 0.65

/** `joinBy` is what tells the two layers apart: the sections join by id, the provinces by CPRO. */
export const joinsBySectionId = (seriesOptions: any): boolean =>
  !!seriesOptions && Array.isArray(seriesOptions.joinBy) && seriesOptions.joinBy[0] === 'id'

export const fillOpacityFor = (isSection: boolean): number =>
  isSection ? SECTION_FILL_OPACITY : PROVINCE_FILL_OPACITY
